import { Params } from '@angular/router';
import { Facet, Facets } from '@app/shared/models/facets.model';

export function transformFacetsToUrlParamsWithLevel(facets: Facets, level: string): Params {
  return Object.keys(facets)
    .map((key) => ({
      key,
      value:
        key === level
          ? JSON.stringify(facets[key])
          : facets[key]
              .map(({ value, display }) =>
                key === 'historicalDates' && display && display !== value
                  ? `${value}|${encodeURIComponent(display)}`
                  : value,
              )
              .join(','),
    }))
    .reduce((acc, { key, value }) => ({ ...acc, [key]: value }), {});
}

export function transformFacetsToUrlParams(facets: Facets): Params {
  return Object.keys(facets)
    .map((key) => ({
      key,
      value: facets[key].map(({ value }) => value).join(','),
    }))
    .reduce((acc, { key, value }) => ({ ...acc, [key]: value }), {});
}

export function hydrateSelectedFacets(facets: Facets, selected: Facets): Facets {
  return Object.keys(selected)
    .map((key) => {
      if (key === 'search' || key === 'dates') {
        return { [key]: selected[key] };
      }
      const matchingFacets: Facet[] =
        facets[key]?.filter((facet: Facet) => {
          return selected[key].some((selectedFacet) => selectedFacet.value === facet.value);
        }) ?? [];
      return { [key]: matchingFacets };
    })
    .reduce((acc, facet) => ({ ...acc, ...facet }), {});
}

export function extractFacetsWithLevel(queryParams: Params, level: string): Facets {
  const facets = {};
  Object.keys(queryParams).forEach((key) => {
    const value = queryParams[key];
    if (key === level) {
      try {
        facets[key] = JSON.parse(value);
      } catch {
        facets[key] = [];
      }
    } else {
      facets[key] = value.split(',').map((facetValue) => {
        if (key === 'historicalDates' && facetValue.includes('|')) {
          const pipeIndex = facetValue.indexOf('|');
          const val = facetValue.slice(0, pipeIndex);
          const display = decodeURIComponent(facetValue.slice(pipeIndex + 1));
          return { value: val, display };
        }
        return { value: facetValue, display: facetValue };
      });
    }
  });
  return facets;
}

export function extractFacets(queryParams: Params): Facets {
  const facets = {};
  Object.keys(queryParams).forEach((key) => {
    const value = queryParams[key];
    facets[key] = value.split(',').map((facetValue) => ({
      value: facetValue,
      display: facetValue,
    }));
  });
  return facets;
}
